import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../../app-error/app-error.model";

import {
	DepositLimit,
	DepositLimitParams,
	DepositLimits,
	DepositLimitType,
	DepositLimitUnconfirmedParams,
} from "./deposit-limit.model";

export const ACTION_PREFIX = "[Deposit Limit]";
export const DEPOSIT_LIMIT_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,

	getUnconfirmed: `${ACTION_PREFIX} Get Unconfirmed`,
	getUnconfirmedSuccess: `${ACTION_PREFIX} Get Unconfirmed Success`,
	getUnconfirmedFail: `${ACTION_PREFIX} Get Unconfirmed Fail`,

	update: `${ACTION_PREFIX} Update`,
	updateSuccess: `${ACTION_PREFIX} Update Success`,
	updateFail: `${ACTION_PREFIX} Update Fail`,

	acceptUnconfirmed: `${ACTION_PREFIX} Accept Unconfirmed`,
	acceptUnconfirmedSuccess: `${ACTION_PREFIX} Accept Unconfirmed Success`,
	acceptUnconfirmedFail: `${ACTION_PREFIX} Accept Unconfirmed Fail`,

	remove: `${ACTION_PREFIX} Remove`,
	removeSuccess: `${ACTION_PREFIX} Remove Success`,
	removeFail: `${ACTION_PREFIX} Remove Fail`,

	declineUnconfirmed: `${ACTION_PREFIX} Decline Unconfirmed`,
	declineUnconfirmedSuccess: `${ACTION_PREFIX} Decline Unconfirmed Success`,
	declineUnconfirmedFail: `${ACTION_PREFIX} Decline Unconfirmed Fail`,

	clear: `${ACTION_PREFIX} Clear ${SYNC_SUFFIX}`,
};

/**
 * @deprecated [fabric-deprecated] - Use DepositLimitService from app-responsible-gaming instead
 */
@Injectable({
	providedIn: "root",
})
export class DepositLimitAction {
	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetAllDepositLimits instead
	 */
	getAll(): Action {
		return createCachedGetAction({
			type: DEPOSIT_LIMIT_ACTION_TYPE.getAll,
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetAllDepositLimits instead
	 */
	getAllSuccess(payload: DepositLimits): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.getAllSuccess,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetAllDepositLimits instead
	 */
	getAllFail(error: AppError): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.getAllFail,
			payload: error,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetUnconfirmedDepositLimits instead
	 */
	getUnconfirmed(): Action {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.getUnconfirmed,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetUnconfirmedDepositLimits instead
	 */
	getUnconfirmedSuccess(payload: DepositLimits): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.getUnconfirmedSuccess,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetUnconfirmedDepositLimits instead
	 */
	getUnconfirmedFail(error: AppError): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.getUnconfirmedFail,
			payload: error,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateDepositLimit instead
	 */
	update(payload: DepositLimitParams): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.update,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateDepositLimit instead
	 */
	updateSuccess(payload: DepositLimit): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.updateSuccess,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateDepositLimit instead
	 */
	updateFail(error: AppError): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.updateFail,
			payload: error,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.AcceptUnconfirmedDepositLimit instead
	 */
	acceptUnconfirmed(payload: DepositLimitUnconfirmedParams): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.acceptUnconfirmed,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.AcceptUnconfirmedDepositLimit instead
	 */
	acceptUnconfirmedSuccess(): Action {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.acceptUnconfirmedSuccess,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.AcceptUnconfirmedDepositLimit instead
	 */
	acceptUnconfirmedFail(error: AppError): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.acceptUnconfirmedFail,
			payload: error,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.AcceptUnconfirmedDepositLimit instead
	 */
	delete(payload: DepositLimitType): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.remove,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.AcceptUnconfirmedDepositLimit instead
	 */
	deleteSuccess(payload: DepositLimit): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.removeSuccess,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.AcceptUnconfirmedDepositLimit instead
	 */
	deleteFail(error: AppError): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.removeFail,
			payload: error,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.DeclineUnconfirmedDepositLimit instead
	 */
	declineUnconfirmed(payload: DepositLimitUnconfirmedParams): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.declineUnconfirmed,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.DeclineUnconfirmedDepositLimit instead
	 */
	declineUnconfirmedSuccess(): Action {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.declineUnconfirmedSuccess,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.DeclineUnconfirmedDepositLimit instead
	 */
	declineUnconfirmedFail(error: AppError): ActionWithPayload {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.declineUnconfirmedFail,
			payload: error,
		};
	}

	clear(): Action {
		return {
			type: DEPOSIT_LIMIT_ACTION_TYPE.clear,
		};
	}
}
